import { FetchResponse } from '../types'
import { getDomainFromURL, getLinkToOpen, getTemplate } from '../helpers'
import { User } from '@wellesley/openapi'
import { FormType } from '../schema'
import { SubmitHandler } from 'react-hook-form'
import safeFetch from 'helpers/safeFetch'

type HookProps = {
  user: User
}

const useGuestFollow = ({ user }: HookProps) => {
  const handleSubmit: SubmitHandler<FormType> = async ({ url }) => {
    const domain = getDomainFromURL(url)

    try {
      const fetchUrl = `${domain}/.well-known/webfinger?resource=${domain}`

      const data = await safeFetch<FetchResponse>({
        url: fetchUrl,
        headers: {
          Accept: 'application/json',
        },
      })

      if (!data) return

      const template = getTemplate(data)
      const link = getLinkToOpen({ template, user })

      if (!link) throw new Error(`Error getting follow link`)

      window.open(link, '_self')
    } catch {
      window.open(`${domain}/authorize_interaction?uri=${user.uri}`, '_self')
    }
  }

  return handleSubmit
}

export default useGuestFollow
